import { render } from "./ColumnItem.vue?vue&type=template&id=335d2ecc&scoped=true&ts=true&lang=pug"
import script from "./ColumnItem.vue?vue&type=script&lang=ts"
export * from "./ColumnItem.vue?vue&type=script&lang=ts"

import "./ColumnItem.vue?vue&type=style&index=0&id=335d2ecc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335d2ecc"]])

export default __exports__